import { Sun, Moon, Monitor, type LucideIcon } from 'lucide-react';
import { useTheme, type ThemeMode } from '@/shared/stores/themeStore';

const icons: Record<ThemeMode, LucideIcon> = { light: Sun, dark: Moon, system: Monitor };
const labels: Record<ThemeMode, string> = {
  light: 'Theme: light (click for dark)',
  dark: 'Theme: dark (click for system)',
  system: 'Theme: system (click for light)',
};

/** Cycles light → dark → system. */
export const ThemeToggle = () => {
  const { mode, cycle } = useTheme();
  const Icon = icons[mode];
  return (
    <button type="button" onClick={cycle} className="btn-icon" title={labels[mode]} aria-label={labels[mode]}>
      <Icon className="h-5 w-5" />
    </button>
  );
};
